/* Maison Lumelle — custom AJAX cart drawer */
(function () {
  'use strict';
  var drawer, scrim, opId = null;

  function money(c) {
    var v = c / 100;
    var s = (v % 1 === 0) ? String(v) : v.toFixed(2).replace('.', ',');
    return s + ' €';
  }
  function esc(s) { return (s == null ? '' : String(s)).replace(/[&<>"]/g, function (m) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[m]; }); }
  function img(url, w) { if (!url) return ''; return url.indexOf('?') > -1 ? url + '&width=' + w : url + '?width=' + w; }

  function getCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  function change(body) {
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) }).then(function (r) { return r.json(); });
  }
  function add(id, qty) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: id, quantity: qty || 1 }) }).then(function (r) { return r.json(); });
  }

  function open() {
    if (!drawer) return;
    drawer.classList.add('is-open'); scrim.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }
  function close() {
    if (!drawer) return;
    drawer.classList.remove('is-open'); scrim.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }

  function itemHTML(it) {
    var variant = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
    return '<div class="lumelle-ci" data-key="' + esc(it.key) + '">' +
      '<a class="lumelle-ci-thumb" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(img(it.image, 200)) + '" alt="">' : '') + '</a>' +
      '<div class="lumelle-ci-main">' +
        '<a class="lumelle-ci-name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
        (variant ? '<div class="lumelle-ci-mat">' + esc(variant) + '</div>' : '') +
        '<div class="lumelle-ci-price">' + money(it.final_price) + '</div>' +
        '<div class="lumelle-ci-row">' +
          '<div class="lumelle-qty"><button type="button" data-act="dec" aria-label="Diminuer">−</button><span>' + it.quantity + '</span><button type="button" data-act="inc" aria-label="Augmenter">+</button></div>' +
          '<button type="button" class="lumelle-ci-rm" data-act="rm"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M4 7h16M9 7V5h6v2M6 7l1 13h10l1-13"/></svg>Retirer</button>' +
        '</div>' +
      '</div></div>';
  }

  function render(cart) {
    if (!drawer) return;
    var items = cart.items.filter(function (i) { return i.id !== opId; });
    var op = cart.items.filter(function (i) { return i.id === opId; })[0];
    var units = items.reduce(function (n, i) { return n + i.quantity; }, 0);

    var titleEl = drawer.querySelector('.lumelle-cart-title');
    if (titleEl) titleEl.textContent = 'Panier (' + units + ')';

    var wrap = drawer.querySelector('.lumelle-cart-items');
    var emptyEl = drawer.querySelector('.lumelle-cart-empty');
    if (units === 0) {
      wrap.innerHTML = '';
      if (emptyEl) emptyEl.style.display = '';
      drawer.classList.add('is-empty');
    } else {
      wrap.innerHTML = items.map(itemHTML).join('');
      if (emptyEl) emptyEl.style.display = 'none';
      drawer.classList.remove('is-empty');
    }

    var subEl = drawer.querySelector('.lumelle-cart-subtotal');
    if (subEl) subEl.innerHTML = money(cart.total_price);
    var kEl = drawer.querySelector('.lumelle-cart-klarna-amt');
    if (kEl) kEl.innerHTML = money(Math.round(cart.total_price / 3));

    var prot = drawer.querySelector('.lumelle-cart-prot');
    var sw = drawer.querySelector('.lumelle-cart-switch');
    var label = drawer.querySelector('.lumelle-prot-label');
    var sub = drawer.querySelector('.lumelle-prot-sub');
    if (op) {
      if (prot) prot.classList.add('on'); if (sw) sw.classList.add('on');
      if (label) label.innerHTML = 'Protection <b>renforcée activée</b>';
      if (sub) sub.textContent = 'Perte, vol et casse pendant le transport : entièrement couverts.';
    } else {
      if (prot) prot.classList.remove('on'); if (sw) sw.classList.remove('on');
      if (label) label.innerHTML = 'Protection <b>standard incluse</b>';
      if (sub) sub.textContent = 'Livraison suivie, retours 30 jours et garantie 3 ans. Ajoutez la protection renforcée ci-dessous.';
    }

    var inCart = {}; cart.items.forEach(function (i) { inCart[i.product_id] = true; });
    var cands = Array.prototype.slice.call(drawer.querySelectorAll('.lumelle-up[data-pid]'));
    var shown = 0;
    cands.forEach(function (c) {
      var pid = parseInt(c.getAttribute('data-pid'), 10);
      if (!inCart[pid] && shown < 2) { c.style.display = ''; shown++; }
      else c.style.display = 'none';
    });
    var upBlock = drawer.querySelector('.lumelle-cart-upsell');
    if (upBlock) upBlock.style.display = shown > 0 && units > 0 ? '' : 'none';
  }

  function refresh(doOpen) {
    return getCart().then(function (cart) { render(cart); if (doOpen) open(); return cart; });
  }

  function bind() {
    drawer = document.querySelector('.lumelle-cart-drawer');
    scrim = document.querySelector('.lumelle-cart-scrim');
    if (!drawer) return;
    opId = parseInt(drawer.getAttribute('data-op-id'), 10) || null;

    drawer.querySelectorAll('[data-cart-close]').forEach(function (b) { b.addEventListener('click', close); });
    if (scrim) scrim.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    drawer.querySelector('.lumelle-cart-items').addEventListener('click', function (e) {
      var btn = e.target.closest('[data-act]'); if (!btn) return;
      var row = btn.closest('.lumelle-ci'); if (!row) return;
      var key = row.getAttribute('data-key');
      var span = row.querySelector('.lumelle-qty span');
      var q = parseInt(span ? span.textContent : '1', 10);
      var act = btn.getAttribute('data-act');
      var nq = act === 'rm' ? 0 : (act === 'inc' ? q + 1 : Math.max(0, q - 1));
      row.style.opacity = '0.5';
      change({ id: key, quantity: nq }).then(render);
    });

    drawer.querySelectorAll('.lumelle-up-add').forEach(function (b) {
      b.addEventListener('click', function () {
        var vid = b.getAttribute('data-vid');
        b.textContent = 'Ajout…';
        add(vid, 1).then(function () { return refresh(false); }).then(function () { b.textContent = '+ Ajouter'; });
      });
    });

    var sw = drawer.querySelector('.lumelle-cart-switch');
    if (sw && opId) {
      sw.addEventListener('click', function () {
        sw.classList.contains('on')
          ? getCart().then(function (c) { var l = c.items.filter(function (i) { return i.id === opId; })[0]; return l ? change({ id: l.key, quantity: 0 }) : c; }).then(render)
          : add(opId, 1).then(function () { return refresh(false); });
      });
    }

    document.querySelectorAll('a[href$="/cart"], a[href*="/cart?"]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); refresh(true); });
    });

    document.addEventListener('cart:refresh', function () { refresh(true); });

    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (f && f.matches && f.matches('form[action$="/cart/add"], form[action*="/cart/add"]')) {
        e.preventDefault();
        var fd = new FormData(f);
        fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } }).then(function () { refresh(true); });
      }
    });

    refresh(false);
  }

  window.LumelleCart = { open: open, close: close, refresh: refresh };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
  document.addEventListener('shopify:section:load', function (e) { if (e.target.querySelector && e.target.querySelector('.lumelle-cart-drawer')) bind(); });
})();
